export default function amapLoader() {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap)
    } else {
      window._AMapSecurityConfig = {
        serviceHost: 'http://data.pengbo-tech.com/_AMapService'
      }

      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src =
        'http://webapi.amap.com/maps?v=1.4.15&callback=initAMap&key=edf30b438ff246bb64911ee25e3fde83'
      script.onerror = reject
      document.head.appendChild(script)
    }
    window.initAMap = () => {
      resolve(window.AMap)
    }
  })
}

export function getLocate(AMap, domId) {
  return new Promise((resolve, reject) => {
    AMap.plugin(['AMap.Geolocation', 'AMap.Geocoder'], () => {
      const geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: false,
        // 设置定位超时时间，默认：无穷大
        timeout: 5000,
        // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
        // buttonOffset: new this.AMap.Pixel(10, 20),
        //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        zoomToAccuracy: true,
        //  定位按钮的排放位置,  RB表示右下
        buttonPosition: 'RB'
      })

      const map = new AMap.Map(domId)
      map.addControl(geolocation)

      function onSuccess(data) {
        resolve(data.position)
      }

      function onError() {
        const { lat, lng } = map.getCenter()
        reject({ lat, lng })
      }

      geolocation.getCurrentPosition()
      AMap.event.addListener(geolocation, 'complete', data => onSuccess(data))
      AMap.event.addListener(geolocation, 'error', err => onError(err))
    })
  })
}
